import type { DatabaseSchemaRow } from '../../repositoryblueprint/framework';

type Props = { items?: DatabaseSchemaRow[] };

export function DatabaseSchemaPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.schema} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.schema}</p>
            <p className="text-lg font-semibold text-brand-600">{item.tables}</p>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.purpose}</p>
          <p className="text-xs text-slate-400">Owner: {item.owner}</p>
        </div>
      ))}
    </div>
  );
}
